import { render, staticRenderFns } from "./PsinEditAbout.vue?vue&type=template&id=663ed2be&scoped=true&"
import script from "./PsinEditAbout.vue?vue&type=script&lang=js&"
export * from "./PsinEditAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663ed2be",
  null
  
)

export default component.exports